import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { useRouteMatch, useHistory, useLocation } from "react-router-dom"
import { useQuery } from 'Hooks'
import { Tree, Dropdown } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Feather from '@sysunite/react-feather'
import { useTreeData } from './TreeDataProvider'
import { onExpandNode } from './TreeDataProvider/helpers'
import { setCurrentItem, setTab, setTabDisabled, setCreatingNode, setNodeFormInitialValues } from 'Actions/explore'
import { getNodeLabel, getUid } from 'Services/WeaverUtils'
import { showActionsPage } from 'Components'
{ TreeNode } = Tree
import { NODE } from 'Types'
import cuid from 'cuid'
import { ContextMenu } from 'Components'

# Separator for node ids in a tree-node's key (which describes a path to the node, from the tree root)
SEPARATOR = cuid()
LIMITED = "#{cuid()}-limited"

TreeView = ({ setCreatingNode, setCurrentItem, setNodeFormInitialValues, setTab, setTabDisabled, relationsToFollow, tabIsLocked, history, height, macros, memberKeys }) ->

  [state, dispatchTreeData] = useTreeData()
  { url } = useRouteMatch()
  { hash }  = useLocation()
  params = useQuery()
  history = useHistory()

  {
    nodeData,
    treeData,
    rootNodes,
    expandedKeys,
    isLoading,
    orientation
  } = state

  renderIcon = (type) ->
    <Feather
      type={type}
      size={18}
      style={{ marginTop: 3 }}
    />

  getNodeActions = (node) ->
    editViaFormItem = {
      key: 'edit-sequence'
      title: 'Edit via form'
      hidden: -> macros.length <= 0
    }

    macroList = macros.map((m) -> m.get('configBlob'))

    createMacroSubMenu = (macroList) ->
      items = _.map(macroList, (macro) ->
        {
          key: _.kebabCase(macro.title)
          title: macro.title
          onClick: ->
            nodeId = node.id()
            showActionsPage({ macro..., nodeId, mode: 'edit', title: 'Edit' })
        }
      )
      if items.length > 0
        editViaFormItem.submenu = items

    typeIds = []
    if node?.type?
      typeIds = node.type.map((t) -> t.id)
    else
      memberKeys.map((k) -> node.relation(k).all().map((t) -> typeIds.push(t.id())))
    typedMacros = macroList.filter((m) -> _.get(m, 'formSequence.onSave.node.typeNode') in typeIds)
    untypedMacros = macroList.filter((m) -> !_.get(m, 'formSequence.onSave.node.typeNode')?)
    createMacroSubMenu([untypedMacros..., typedMacros...])

    createSubNode = {
      key: 'create-sub-node',
      title: 'Create Sub Node',
      hidden: -> !node?
      requiresWriteAccess: true
      onClick: ({ domEvent }) ->
        setNodeFormInitialValues({ graph: node.graph, relations: [{ keys: undefined, targets: [getUid(node)] }]})
        setCreatingNode(true)
        domEvent.stopPropagation()
    }

    [ createSubNode, editViaFormItem ]

  getEmptySpaceActions = ->
    [{
      key: 'create-node'
      title: 'Create node'
      requiresWriteAccess: true
      onClick: ({ domEvent }) ->
        setCreatingNode(true)
        domEvent.stopPropagation()
    }]

  getTreeNodeProps = (key, address, isRecursiveRef = false) ->
    if key is LIMITED
      {
        key: address
        title: 'Results are limited to 400'
        icon: undefined
      }
    else if node = nodeData[key]
      { type, nodeId } = node
      if isRecursiveRef
        restProps = {
          icon: renderIcon('corner-left-up')
          isLeaf: true
          children: []
        }
      else
        restProps = {
          icon: renderIcon('hexagon')
          isLeaf: !treeData[key]?[0]
          children: (
            if expandedKeys.indexOf(address) is -1
              []
            else
              buildNodes(treeData[key], address)
          )
        }

      treeProps = {
        key: address
        title: getNodeLabel(node)
        node
        restProps...
      }
    else
      {
        key: address
        title: <LoadingOutlined />
        icon: undefined
      }

  catchLimited = (data) ->
    if data.length is 400
      withLimit = [data..., LIMITED]
      _.orderBy(withLimit, [(id) -> if id is LIMITED then id else getNodeLabel(nodeData[id])])
    else
      _.orderBy(data, [(id) -> getNodeLabel(nodeData[id])])

  buildNodes = (data = [], parentAddress) ->
    # Key by full tree address (instead of nodeId) to permit
    # recursive tree structures without infinite loops
    ordered = catchLimited(data).map((key) ->
      isRecursiveRef = parentAddress.split(SEPARATOR).indexOf(key.split(SEPARATOR).lastItem) isnt -1
      address = parentAddress + SEPARATOR + key
      getTreeNodeProps(key, address, isRecursiveRef)
    )

  renderTitle = ({ node, title }) ->
    if node?
      <div style={{ display: 'flex' }}>
        <ContextMenu actions={ getNodeActions(node) }>
          <div data-testid="treeNode-#{title}">
            { title }
          </div>
        </ContextMenu>
        <ContextMenu actions={ getEmptySpaceActions() } >
          <div style={{ flexGrow: 1 }} />
        </ContextMenu>
      </div>
    else
      title

  <div className="instance-tree">
    <Tree
      blockNode={true}
      titleRender={(item) -> renderTitle(item)}
      height={height - 225}
      showIcon={true}
      expandedKeys={expandedKeys}
      onExpand={(expandedKeys, { node, expanded }) ->
        key = node.key
        nodeId = key.split(SEPARATOR).slice(-1).lastItem
        onExpandNode({
          key,
          node: nodeData[nodeId],
          relationsToFollow,
          isExpanded: expanded,
          orientation,
          dispatch: dispatchTreeData
        })
      }
      onSelect={(keys, { node }) ->
        unless node.key.split(SEPARATOR).lastItem is LIMITED
          id = node.key.split(SEPARATOR).lastItem
          setCurrentItem({
            id,
            label: node.title
            type: NODE
          })
          setTabDisabled({ key: 'attributes', disabled: false })
          params.set('tab', 'attributes')
          history.push({ pathname: url, search: params.toString(), hash }) unless tabIsLocked
      }
      style={{ whiteSpace: 'nowrap' }}
      treeData={buildNodes(rootNodes, '')}
    />

  </div>

export default connect(
  ({ explore }) ->
    {
      height: explore.height
      tabIsLocked: explore.tabIsLocked
      macros: explore.macros
      memberKeys: explore.memberKeys
    }
  , { setCurrentItem, setTab, setTabDisabled, setCreatingNode, setNodeFormInitialValues }
)(withRouter(TreeView))
